import React, { useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import aislogo from '../../includes/images/asi-logo-light.png';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../containers/Login/state/operations';

import { WEBHRIS_OLD, WEBHRIS_OLD_LOGIN_URL, IDS_TOKEN_COOKIE, URL_ROOT } from '../../config/settings';
import cookie from 'react-cookies';

const MainHeader = ({ toggleSidebar }) => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(({ auth }) => auth.isAuthenticated)
    const publicData = JSON.parse(localStorage.getItem('publicLoginData'))

    const onToggleSidebar = (e) => {
        e.preventDefault();
        toggleSidebar();
    }

    const handleLogout = (e) => {
        e.preventDefault();
        dispatch(logoutUser());
        window.location.replace(WEBHRIS_OLD_LOGIN_URL + "?redirect=hrrec")
    }

    const handPublicLogout = (e) => {
        e.preventDefault();
        localStorage.removeItem('publicLoginData')
        window.location.replace(URL_ROOT + `/apply`)
    }

    return (
        <header id='header' className='header-time-keeping'>
            {/*{isAuthenticated &&
                <a href='#' className='icon-menu-bar header-toggle-bar toggle-width left-nav' onClick={onToggleSidebar}><i className='fa fa-bars' aria-hidden='true'></i></a>
            }*/}
            {isAuthenticated ? (
                <>
                    <a href='#' className='icon-menu-bar header-toggle-bar toggle-width left-nav' onClick={onToggleSidebar}><i className='fa fa-bars' aria-hidden='true'></i></a>
                    <a href={WEBHRIS_OLD + '/dashboard'} className='logo left-nav'>
                        <img className='logo-time-keeping' src={aislogo} alt='Portal Time Keeping' />
                    </a>
                </>
            ) : (
                publicData !== null ? (
                    <>
                        <a href='#' className='icon-menu-bar header-toggle-bar toggle-width left-nav' onClick={onToggleSidebar}><i className='fa fa-bars' aria-hidden='true'></i></a>
                        <a className='logo left-nav'>
                            <img className='logo-time-keeping' src={aislogo} alt='Portal Time Keeping' />
                        </a>
                    </>
                ) : (
                    <>
                        <a className='logo left-nav'>
                            <img className='logo-time-keeping' src={aislogo} alt='Portal Time Keeping' />
                        </a>
                    </>
                )
            )}


            {/* <Link to='/' className='logo left-nav'>
                <img className='logo-time-keeping' src={aislogo} alt='Portal Time Keeping' />
            </Link> */}
            {isAuthenticated ? (
                <form className="header-right-field">
                    <Dropdown>
                        <Dropdown.Toggle variant="success" className='is-compressed'>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href={WEBHRIS_OLD + '/dashboard'}><i className='fa fa-refresh' /> Change Password</Dropdown.Item>
                            <Dropdown.Item href="/logout" onClick={handleLogout}><i className='fa fa-sign-out' /> Log-out</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </form>
            ) : (
                publicData !== null && (
                    <form className="header-right-field">
                        <Dropdown>
                            <Dropdown.Toggle variant="success" className='is-compressed'>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="/logout" onClick={handPublicLogout}><i className='fa fa-sign-out' /> Log-out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </form>
                )
            )}
        </header>

        // <Navbar bg='dark' variant='dark' expand='lg'>
        //     <Container>
        //         <Navbar.Brand>Payroll</Navbar.Brand>
        //         <Navbar.Toggle aria-controls='basic-navbar-nav' />
        //         <Navbar.Collapse id='basic-navbar-nav'>
        //             <Nav className='mr-auto'>
        //                 {rootRoutes.map((route, i) => {
        //                     return (
        //                         route.path && route.showNav ? <Nav.Link as={Link} key={i} href={route.path} to={route.path}>{route.label}</Nav.Link> : ''
        //                     );
        //                 })}
        //             </Nav>
        //             <Nav>
        //                 <Nav.Link onClick={() => props.logoutUser()}>Logout</Nav.Link>
        //             </Nav>
        //         </Navbar.Collapse>
        //     </Container>
        // </Navbar>
    );
};

export default MainHeader;